import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _asyncToGenerator from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
import _regeneratorRuntime from "/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React, { useContext, useEffect, useState } from 'react';
import lunr from 'lunr';
import styled from 'styled-components';
import styles from './SearchBlade.style';
import Search from '../../atoms/Search';
import SearchResult from '../../molecules/SearchResult';
import { Context } from '../../../global-state-context';
var SearchBlade = function SearchBlade(_ref) {
  var className = _ref.className;
  var _useContext = useContext(Context),
    searchQuery = _useContext.searchQuery;
  var _useState = useState(null),
    errorMessage = _useState[0],
    setErrorMessage = _useState[1];
  var _useState2 = useState([]),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = useState([]),
    results = _useState3[0],
    setResults = _useState3[1];
  var _useState4 = useState(null),
    idx = _useState4[0],
    setIdx = _useState4[1];
  var search = function search(data) {
    var lunrIdx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : idx;
    if (!searchQuery || !lunrIdx) {
      setResults([]);
      return;
    }
    var searchResults = lunrIdx.search(searchQuery);
    var results = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (_ref2) {
      var ref = _ref2.ref;
      return data.find(function (doc) {
        return (doc === null || doc === void 0 ? void 0 : doc.id) == ref;
      });
    });
    setResults(results || []);
  };
  var getData = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resultsResponse, resultsData, indexingResponse, indexingData, lunrIdx;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return fetch('/results.json');
            case 3:
              resultsResponse = _context.sent;
              _context.next = 6;
              return resultsResponse.json();
            case 6:
              resultsData = _context.sent;
              _context.next = 9;
              return fetch('/indexing.json');
            case 9:
              indexingResponse = _context.sent;
              _context.next = 12;
              return indexingResponse.json();
            case 12:
              indexingData = _context.sent;
              lunrIdx = lunr.Index.load(indexingData);
              setData(resultsData);
              setIdx(lunrIdx);
              return _context.abrupt("return", {
                resultsData: resultsData,
                idx: lunrIdx
              });
            case 19:
              _context.prev = 19;
              _context.t0 = _context["catch"](0);
              console.error('Error while fetching results', _context.t0);
              setErrorMessage('An error occurred while fetching search results. Please, refresh the page and try again.');
            case 23:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 19]]);
    }));
    return function getData() {
      return _ref3.apply(this, arguments);
    };
  }();
  useEffect(function () {
    _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var resultsData, lunrIdx, _yield$getData, _data, _idx;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              resultsData = data;
              lunrIdx = idx;
              if (idx) {
                _context2.next = 10;
                break;
              }
              _context2.next = 5;
              return getData();
            case 5:
              _yield$getData = _context2.sent;
              _data = _yield$getData.resultsData;
              _idx = _yield$getData.idx;
              resultsData = _data;
              lunrIdx = _idx;
            case 10:
              search(resultsData, lunrIdx);
            case 11:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  }, [searchQuery]);
  return __jsx("div", {
    className: "nva-search-blade ".concat(className)
  }, __jsx("div", {
    className: "l-grid"
  }, __jsx(Search, {
    className: "l-col-full"
  })), __jsx("div", {
    className: "nva-search-blade__results-wrapper l-grid"
  }, searchQuery && __jsx("div", {
    className: "nva-search-blade__results-top l-col-full"
  }, __jsx("h2", {
    className: "nva-search-blade__results-title u-h2 u-m-0"
  }, "Results"), __jsx("p", {
    className: "nva-search-blade__results-stats u-body2 u-m-0"
  }, results.length, " ", results.length === 1 ? 'result' : 'results', " for \"", searchQuery, "\"")), errorMessage && __jsx("div", {
    className: "nva-search-blade__error-wrapper l-col-full"
  }, __jsx("p", {
    className: "nva-search-blade__error-message u-m-0"
  }, errorMessage)), __jsx("div", {
    className: "nva-search-blade__results l-col-full"
  }, results.map(function (result) {
    return __jsx(SearchResult, _extends({
      key: result === null || result === void 0 ? void 0 : result.id
    }, result));
  }))));
};
export default styled(SearchBlade).withConfig({
  componentId: "sc-of2wxt-0"
})(["", ";"], styles);